import { render, staticRenderFns } from "./ServiceSearch.vue?vue&type=template&id=5bc9b22b"
import script from "./ServiceSearch.vue?vue&type=script&lang=js"
export * from "./ServiceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports